import React, { useContext, useEffect, useState } from 'react';
import Splide from '@splidejs/splide';
import { GetAllBanner, GetRestaurantId } from 'services/Api/Module/Banner';
import ModalContext from 'contexts/ModalContext';
import { useNavigate } from 'react-router-dom';
// import '@splidejs/splide/dist/css/splide.min.css';

const Banner = () => {
  const [banner, setBanner] = useState([]);
  const [restaurant, setRestaurant] = useState();
  const navigate = useNavigate();
  const { mAlert } = useContext(ModalContext);
  const fetchGetAllBanner = async () => {
    try {
      const response = await GetAllBanner();
      const resData = response?.data;
      if (resData.resultCode === 20000) {
        setBanner(resData.resultData);
      } else {
        mAlert.info({
          title: "ไม่พบ banner",
          subTitle: "ไม่พบ banner",
          content: "",
          onClose: () => { },
        });
      }
    } catch (err) {
      console.log('err ', err);
      mAlert.info({
        title: "แจ้งเตือน",
        subTitle: "มีบางอย่างผิดพลาด",
        content: "",
        onClose: () => { },
      });
    }
  };
  const fetchGetRestaurantId = async (payload, couponId) => {
    try {
      const response = await GetRestaurantId({ params: payload });
      const resData = response?.data;
      if (resData.resultCode === 20000) {
        setRestaurant(resData.resultData);
        navigate(`/coupon-detail?couponId=${couponId}&restaurantId=${resData.resultData[0].restaurantId}&branchId=${resData.resultData[0].branchId}`)
      } else {
        mAlert.info({
          title: "ไม่พบ restaurant",
          subTitle: "ไม่พบ restaurant",
          content: "",
          onClose: () => { },
        });
      }
    } catch (err) {
      console.log('err ', err);
      mAlert.info({
        title: "แจ้งเตือน",
        subTitle: "มีบางอย่างผิดพลาด",
        content: "",
        onClose: () => { },
      });
    }
  };
  const getFirstWord = (str) => {
    return str.split(',')[0];
  };
  const handleBannerClick = (banner) => {
    if(banner.bannerType == 0){
      console.log('click type 0')
      let payload = {
        branchName : getFirstWord(banner.restaurantBranchListStr)
      }
      fetchGetRestaurantId(payload,banner.couponId)
    }else{
      window.location.href = banner.bannerlink
      console.log('click type 1')
    }
    
  }
  useEffect(() => {
    fetchGetAllBanner();
  }, []);
  useEffect(() => {
    const splide = new Splide('#slideHeroBanner', {
      type: 'loop',
      pagination: true,
      autoplay: true,
      pauseOnHover: true,
      arrows: false,
      gap: '6px',
      padding: '24px',
      interval: 5000, 
    });
    splide.mount();

    return () => splide.destroy();
  }, [banner]);

  return (
    <section id="pBanner">
      <div className="bBanner">
        <div className="splide" id="slideHeroBanner">
          <div className="splide__slider">
            <div className="splide__track">
              <ul className="splide__list">
                {banner.map((bannerItem, index) => (
                  <li className="splide__slide" key={index}>
                    <a onClick={() => handleBannerClick(bannerItem)} target="_blank" rel="noopener noreferrer">
                      <div className="bannerContent">
                        <img src={bannerItem.bannerImg ? bannerItem.bannerImg :"https://dummyimage.com/684x360/667085/fff"} alt={`Banner ${index}`}/>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="splide__progress">
              <div className="splide__progress__bar"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
